
export const AuthErrorCode = code => {
    console.error(`Error al autenticar: ${code}`)
    switch(code) {
        case 'auth/email-already-in-use':
            return "Este correo ya está siendo usado por otro usuario"
        case 'auth/user-disabled':
            return "Este usuario ha sido deshabilitado"
        case 'auth/operation-not-allowed':
            return "Operación no permitida"
        case 'auth/invalid-email':
            return "Correo electrónico no valido"
        case 'auth/wrong-password':
            return "Contraseña incorrecta"
        case 'auth/user-not-found':
            return "No se encontró cuenta del usuario con el correo especificado"
        case 'auth/network-request-failed':
            return "Promblema al intentar conectar al servidor"
        case 'auth/weak-password':
            return "Contraseña muy debil o no válida"
        case 'auth/missing-email':
            return "Hace falta registrar un correo electrónico"
        case 'auth/internal-error':
            return "Error interno"
        case 'auth/invalid-custom-token':
            return "Token personalizado invalido"
        case 'auth/too-many-requests':
            return "Ya se han enviado muchas solicitudes al servidor"
        case 'auth/popup-closed-by-user':
            return 'Cancelado por el usuario'
        default:
            return "Error inesperado, vuelva a intentar"
        }
}


/*

extension FirestoreErrorCode {
    var description: String? {
        switch self {
        case .cancelled:
            return "Operación cancelada"
        case .unknown:
            return "Error desconocido"
        case .invalidArgument:
            return "Argumento no valido"
        case .notFound:
            return "No se encotró el documento"
        case .alreadyExists:
            return "El documento que se pretende crear, ya existe"
        case .permissionDenied:
            return "No tienes permisos para realizar esta operación"
        case .aborted:
            return "Operación abortada"
        case .outOfRange:
            return "Rango invalido"
        case .unimplemented:
            return "Esta operación no ha sido implementada o no es soportada aún"
        case .internal:
            return "Error interno"
        case .unavailable:
            return "Por el momento el servicio no está disponible, intenta más tarde"
        case .unauthenticated:
            return "Usuario no autenticado"
        default:
            return nil
        }
    } }

extension StorageErrorCode {
var description: String? {
    switch self {
    case .unknown:
        return "Error desconocido"
    case .quotaExceeded:
        return "El espacio para guardar archivos ha sido sobrepasado"
    case .unauthenticated:
        return "Usuario no autenticado"
    case .unauthorized:
        return "Usuario no autorizado para realizar esta operación"
    case .retryLimitExceeded:
        return "Tiempo de espera excedido. Favor de intentar de nuevo"
    case .downloadSizeExceeded:
        return "El tamaño de descarga excede el espacio en memoria"
    case .cancelled:
        return "Operación cancelada"
    default:
        return nil
    }
} }

public extension Error {
var localizedDescription: String {
    let error = self as NSError
    if error.domain == AuthErrorDomain {
        if let code = AuthErrorCode(rawValue: error.code) {
            if let errorString = code.description {
                return errorString
            }
        }
    }else if error.domain == FirestoreErrorDomain {
        if let code = FirestoreErrorCode(rawValue: error.code) {
            if let errorString = code.description {
               return errorString
            }
        }
    }else if error.domain == StorageErrorDomain {
        if let code = StorageErrorCode(rawValue: error.code) {
            if let errorString = code.description {
                return errorString
            }
        }
    }
    return error.localizedDescription
} }

*/